import DangerousWithSanitization from '@base/DangerousWithSanitization';
import { SECTION_NAV_INSTRUCTIONS } from '../../constants';
import { Section, StyledH4, StyledLi, StyledOl, StyledP1 } from './Common';

const SectionNavigation = () => {
  return (
    <Section>
      <StyledH4>Navigating through sections</StyledH4>
      <StyledOl>
        {SECTION_NAV_INSTRUCTIONS.map((info, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <StyledLi key={index}>
              <DangerousWithSanitization as={StyledP1} html={info.text} />
            </StyledLi>
          );
        })}
      </StyledOl>
    </Section>
  );
};

export default SectionNavigation;
